import { render, staticRenderFns } from "./product-popup-edit-Tab-Bath-ProductList.vue?vue&type=template&id=16ba64be"
import script from "./product-popup-edit-Tab-Bath-ProductList.vue?vue&type=script&lang=js"
export * from "./product-popup-edit-Tab-Bath-ProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ba64be')) {
      api.createRecord('16ba64be', component.options)
    } else {
      api.reload('16ba64be', component.options)
    }
    module.hot.accept("./product-popup-edit-Tab-Bath-ProductList.vue?vue&type=template&id=16ba64be", function () {
      api.rerender('16ba64be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/product-management/product-popup-edit-Tab-Bath-ProductList.vue"
export default component.exports